import { render, staticRenderFns } from "./bank-status.vue?vue&type=template&id=38d21a2e&"
import script from "./bank-status.vue?vue&type=script&lang=js&"
export * from "./bank-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports